export default __webpack_public_path__ + "static/media/safari-pinned-tab.16f9aed9.svg";